import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/products_/$productId')({
  staticData: { title: 'Product' },
})
